export default class WorkItemProject {
  id: string;

  name: string;

  constructor(obj: any) {
    this.id = obj.id;
    this.name = obj.name;
  }

  public static of(obj: any): WorkItemProject {
    return new WorkItemProject(obj);
  }
}
